import { render } from "./OperationsPage.vue?vue&type=template&id=02813e48"
import script from "./OperationsPage.vue?vue&type=script&lang=js"
export * from "./OperationsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__